import { TimeRangeOption } from '../time-range';

export class ChartHelper {
  public static getChartTimeRange(
    timeRange: TimeRangeOption | string,
    startTimestamp = new Date().valueOf(),
  ): {
    from: number;
    to: number;
  } {
    if (typeof timeRange === 'string') {
      const date = new Date();
      date.setUTCHours(0, 0, 0, 0);
      return { from: date.valueOf(), to: new Date().valueOf() };
    } else {
      //const timeRange = _timeRange as TimeRangeOption;
      let minDate = timeRange.subtract(startTimestamp, timeRange.defaultRange);
      let maxDate = timeRange.add(startTimestamp, timeRange.defaultRange);

      if (maxDate.valueOf() > new Date().valueOf()) {
        maxDate = new Date();
      }

      // Round up both dates to the next full unit
      if (timeRange.shownUnit) {
        minDate = timeRange.shownUnit.roundUp(minDate);
        maxDate = timeRange.shownUnit.roundUp(maxDate);
      } else {
        minDate = timeRange.roundUp(minDate);
        maxDate = timeRange.roundUp(maxDate);
      }

      return { from: minDate.valueOf(), to: maxDate.valueOf() };
    }
  }

  public static updateTimeRange(range: { from: number; to: number }) {
    const delta = range.to - range.from;
    const now = new Date().valueOf();
    return { from: now - delta, to: now };
  }
}
